module.exports = "/_next/static/images/icon-search-4c5351ee6418ed32280e8ce78bcfd21f.png";